
import React from 'react';
import { Button } from "@/components/ui/button";
import { useNavigate } from 'react-router-dom';

interface HeaderProps {
  onScrollToSection: (sectionId: string) => void;
}

export const Header: React.FC<HeaderProps> = ({
  onScrollToSection
}) => {
  const navigate = useNavigate();
  return <header className="bg-white sticky top-0 z-50">
      <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex items-center">
            <div className="bg-transparent py-1 rounded font-bold text-xl inline-block px-[4px]">
              <img src="/arendaplus-logo-full.svg" alt="ArendaPro+" className="h-6" />
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button onClick={() => onScrollToSection('features')} className="text-gray-600 hover:text-blue-600 transition-colors">
              О продукте
            </button>
            <button onClick={() => onScrollToSection('features')} className="text-gray-600 hover:text-blue-600 transition-colors">
              Возможности
            </button>
            <button onClick={() => onScrollToSection('cta')} className="text-gray-600 hover:text-blue-600 transition-colors">
              Тарифы
            </button>
            <Button variant="outline" onClick={() => navigate('/login')}>
              Войти
            </Button>
          </nav>

          {/* Mobile menu - simplified for now */}
          <div className="md:hidden">
            <Button variant="outline" size="sm" onClick={() => navigate('/login')}>
              Войти
            </Button>
          </div>
        </div>
      </div>
    </header>;
};
